// extracted by mini-css-extract-plugin
export default {"wrap":"LegalPage_wrap__NZ-3u","container":"LegalPage_container__yb+Vc","card":"LegalPage_card__UZaGN"};